import {post,get} from '../../../libs/ajax.js';

export default {

    /* 【列表相关接口】 */

    //  智能托管-托管规则列表 - 下拉筛选
    getIntelligentGetSearchLists(data,options){
        return get('/intelligent/managed/get_search_list', data, options);
    },

    //  智能托管-托管规则列表 - 查询
    getIntelligentGetLists(data,options){
        return post('/intelligent/managed/get_list', data, options);
    },

    //  智能托管-托管规则列表 - 删除
    postIntelligentDelete(data,options){
        return post('/intelligent/managed/delete', data, options);
    },

    //  智能托管-托管规则列表 - 修改
    postIntelligentChangeStatus(data,options){
        return post('/intelligent/managed/change_status', data, options);
    },

    //  智能托管-运行记录列表 - 下拉筛选
    getManagedGetSearchList(data,options){
        return get('/intelligent/managed/run_record/get_search_list', data, options);
    },
    //  智能托管-运行记录列表 - 查询
    postManagedGetList(data,options){
        return post('/intelligent/managed/run_record/list', data, options);
    },
    // 智能托管-运行记录列表 - 运行详情
    getRunRecordDetail(data,options){
        return post('/intelligent/managed/run_record/detail', data, options);
    },

    //  智能托管-触发记录列表 - 下拉筛选
    getTriggerGetSearchList(data,options){
        return get('/intelligent/managed/trigger/get_search_list', data, options);
    },
    //  智能托管-触发记录列表 - 查询
    postTriggerGetList(data,options){
        return post('/intelligent/managed/trigger/get_list', data, options);
    },
    //  智能托管-触发记录列表 - 详情列表与导出
    getTriggerDetail(data,options){
        return post('/intelligent/managed/trigger/detail', data, options);
    },
    //  智能托管-触发记录列表 - 详情导出
    getTriggerExport(data,options){
        return post('/intelligent/managed/trigger/detail_export', data, options);
    },


    /* 【创建与编辑相关】 */

    //  智能托管-获取规则配置类
    getConfig(data,options){
        return get('/intelligent/managed/get_config', data, options);
    },
    //  智能托管-目标维度获取维度筛选配置项
    getDimensionConfig(data,options){
        return get('/intelligent/dimension/get_dimension_config', data, options);
    },
    //  智能托管-维度筛选下拉选项搜索列表
    getDimensionSearchList(data,options){
        return post('/intelligent/dimension/search_detail', data, options);
    },
    //  智能托管-维度筛选下拉选项-详情内容
    getDimensionDetailInfo(data,options){
        return post('/intelligent/dimension/search_detail', data, options);
    },
    //  智能托管-指定通知人筛选-批量导入
    getNotifyUserList(data,options){
        return get('/intelligent/user/list', data, options);
    },
    // 智能托管-获取三类数据对比值配置
    getComparativeValueConfig(data,options){
        return get('/intelligent/managed/get_comparative_value_config', data, options);
    },
    //  智能托管-获取规则详情
    getRuleInfo(data,options){
        return get('/intelligent/managed/get_detail', data, options);
    },
    //  智能托管-复制-获取规则详情
    getCopyRuleInfo(data,options){
        return get('/intelligent/managed/copy_info', data, options);
    },
    //  智能托管-添加规则
    addRule(data,options){
        return post('/intelligent/managed/add', data, options);
    },
    //  智能托管-编辑规则
    editRule(data,options){
        return post('/intelligent/managed/update', data, options);
    },
    // 智能托管-校验KPI数据是否维护
    checkKpiData(data,options){
        return get('/intelligent/managed/check_kpi_data', data, options);
    },
    // 运行记录列表-详情筛选
    getSearchDetail(data,options){
        return post('/intelligent/managed/run_record/get_search_detail', data, options);
    },
    // 触发记录详情-列表
    postInfoListApi(data,options){
        return post('/intelligent/managed/trigger/action/detail', data, options);
    },
    // 触发记录详情-下拉选择
    postInfoSelectApi(data,options){
        return post('/intelligent/managed/trigger/action/get_search_list', data, options);
    }
}
